/**
 * PATH: apps/qa/src/pages/new-inspection/jobFromV2Row.ts
 * FILE_ID: QA-NEWINSPECTION-V2-JOB-001
 * PURPOSE: Map one /api/v2/jobs/ row onto the QA Job the wizard already renders.
 */
import type { Job } from './inspection-types'

// Reused from: packages/job-hub/src/jobs-list/gateway/platformJobsListGateway.ts (searchSuggestions: same endpoint and params)
export function jobFromV2Row(row: Record<string, unknown>): Job {
  return {
    job_id: Number(row.id),
    job_number: typeof row.job_number === 'string' ? row.job_number : String(row.id ?? ''),
    display_name: typeof row.display_name === 'string' ? row.display_name : null,
    client: typeof row.client_name === 'string' ? row.client_name : null,
    site: typeof row.site_address === 'string' ? row.site_address : null,
    status: typeof row.status === 'string' ? row.status : null,
    combined_status: typeof row.combined_status === 'string' ? row.combined_status : null,
    project_manager: typeof row.project_manager_name === 'string' ? row.project_manager_name : null,
  }
}
